import { lazy } from "react";
import { PATHS } from "@/lib/router";
import { useAuthStore } from "@/features/auth/hooks";

import { FeatureProvider, Feature_NAMESPACES } from "@/lib/i18n";

const AdminOrganizationPage = lazy(
  () => import("./pages/AdminOrganizationPage"),
);
const OrganizationPage = lazy(() => import("./pages/OrganizationPage"));

const OrganizationEntry = () => {
  const { user } = useAuthStore();

  const isAdmin =
    user?.role === "business_unit" || user?.role === "system_admin";

  return isAdmin ? <AdminOrganizationPage /> : <OrganizationPage />;
};

export const organizationRoutes = [
  {
    path: PATHS.ORGANIZATION,
    element: (
      <FeatureProvider namespace={Feature_NAMESPACES.ORGANIZATION}>
        <OrganizationEntry />
      </FeatureProvider>
    ),
    handle: { permission: { resource: "organization", action: "view" } },
  },
];
